import z from "zod";
import { emailRegex } from "../../../../../lib/regex";

export const newEmployeeSchema = z.object({
    name: z.string()
        .min(1, "Inserire il nome")
        .max(50, "Nome troppo lungo (max 50 caratteri)")
        .refine((val) => {
            if (!val || val === undefined || val === "" || val === null) return false;
            const cleaned = val.trim().replaceAll(/[^\p{L}\p{N}\s\-']/gu, "");
            return cleaned.length > 0;
        }, {
            message: "Nome non valido: sono ammessi solo lettere, numeri, spazi, trattini e apostrofi"
        }),

    surname: z.string()
        .min(1, "Inserire il cognome")
        .max(50, "Cognome troppo lungo (max 50 caratteri)")
        .refine((val) => {
            if (!val || val === undefined || val === "" || val === null) return false;
            const cleaned = val.trim().replaceAll(/[^\p{L}\p{N}\s\-']/gu, "");
            return cleaned.length > 0;
        }, {
            message: "Cognome non valido: sono ammessi solo lettere, numeri, spazi, trattini e apostrofi"
        }),

    phone: z.string()
        .refine((val) => {
            if (!val || val === undefined || val === "" || val === null) return true;
            if (/[''´`'\u200B\u200C\u200D\uFEFF]/.test(val)) {
                return false;
            }

            let cleaned = val.trim().replaceAll(/[\s\-\.]/g, "");

            if (cleaned.startsWith("+39")) cleaned = cleaned.substring(3);
            else if (cleaned.startsWith("0039")) cleaned = cleaned.substring(4);

            if (!/^\d+$/.test(cleaned)) return false;

            return cleaned.length === 10 && cleaned.startsWith("3");
        }, {
            message: "Il numero selezionato non è un cellulare"
        })
        .optional(),

    emails: z.array(
        z.string().nullable().refine((val) => {
            if (!val || val === undefined || val === "" || val === null) return true;
            return emailRegex.test(val) && !val.includes(" ");
        }, {
            message: "Email non valida"
        })
    ).optional().nullable(),

    linkedinProfile: z.string()
        .refine((val) => {
            if (!val || val === undefined || val === "" || val === null) return true;
            try {
                new URL(val);
                return true;
            } catch {
                return false;
            }
        }, {
            message: "URL LinkedIn non valido"
        })
        .optional(),

    role: z.string().optional(),

    department: z.string().optional(),

    privacy: z.boolean().optional().nullable(),

    particularities: z.array(z.string())
        .refine((val) => {
            if (!val || val.length === 0) return true;
            return val.every(p => /^[\p{L}\p{N}]+$/u.test(p));
        }, {
            message: "Particolarità devono essere stringhe alfanumeriche senza spazi"
        })
        .optional(),

    companyName: z.string({ message: "Nome azienda richiesto" }).optional(),
    companyVat: z.string({ message: "P. IVA azienda richiesto" }).optional(),
    companyPhones: z.array(z.object({
        phone: z.string().refine((val) => {
            if (!val || val === undefined || val === "" || val === null) return true;
            let cleaned = val.trim();
            if (cleaned.startsWith("+39")) cleaned = cleaned.substring(3);
            else if (cleaned.startsWith("0039")) cleaned = cleaned.substring(4);
            cleaned = cleaned.replace(/[\s\-\.\/()\+]/g, "");
            return /^\d+$/.test(cleaned) &&
                cleaned.length >= 6 &&
                cleaned.length <= 12 &&
                (cleaned.startsWith("0") || cleaned === "011111111111");
        }, {
            message: "Telefono non valido: deve iniziare con 0 e avere 6-12 cifre"
        }),
        note: z.string().optional().nullable(),
    })).min(1, "È richiesto almeno un numero di telefono").optional().nullable(),
});

export type NewEmployeeFormValues = z.infer<typeof newEmployeeSchema>;